module.exports = __webpack_public_path__ + "static/media/Administrative Penalty Order - Ehsan Forouzandeh.92866680.pdf";